import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type {
  PlacementBanner,
  PlacementNavigationBar,
  PlacementSearchKeyword,
  PlacementSearchTopBanner,
} from '~/api/model';

// Response 타입 (Zod Model 재사용 — OAISchema 금지, api-typegen §0)
type NavigationBarResponse = PlacementNavigationBar[];
type BannerResponse = PlacementBanner[];
type SearchKeywordResponse = PlacementSearchKeyword[];
type SearchTopBannerResponse = PlacementSearchTopBanner[];

export interface PlacementDataSource {
  getNavigationBars(businessId: number): Promise<NavigationBarResponse>;
  getBanners(businessId: number, placement: string): Promise<BannerResponse>;
  getSearchKeywords(
    businessId: number,
    placement: string,
  ): Promise<SearchKeywordResponse>;
  getSearchTopBanners(businessId: number): Promise<SearchTopBannerResponse>;
}

export class PlacementDataSourceImpl implements PlacementDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getNavigationBars(businessId: number) {
    return this.client.request<NavigationBarResponse>({
      url: '/api/market-place/v1/placements/navigation-bars-new',
      method: 'get',
      params: { businessId },
    });
  }

  async getBanners(businessId: number, placement: string) {
    return this.client.request<BannerResponse>({
      url: '/api/market-place/v1/placements/banners',
      method: 'get',
      params: { businessId, placement },
    });
  }

  async getSearchKeywords(businessId: number, placement: string) {
    return this.client.request<SearchKeywordResponse>({
      url: '/api/market-place/v1/placements/search-keywords',
      method: 'get',
      params: { businessId, placement },
    });
  }

  async getSearchTopBanners(businessId: number) {
    return this.client.request<SearchTopBannerResponse>({
      url: '/api/market-place/v1/placements/search-top-banners',
      method: 'get',
      params: { businessId },
    });
  }
}

export const placementDataSource = new PlacementDataSourceImpl();
